// require('bootstrap/dist/css/bootstrap.css')
require('./styles/bootstrap-theme.css')

require('../bower_components/components-font-awesome/css/font-awesome.css')


// WEBPACK FOOTER //
// ./src/require.css.js